export default __webpack_public_path__ + "static/SR France - Contact alimentaire des emballages - Note d'information-c923a666f139de180ed782c5c06a1a33.pdf";